import { IContract, IContractGoal, IContractTerms, IContractType } from "../bundles/entities.bundle";
import { TemplateMeasureDetails } from "../bundles/models.bundle";



export class ContractDetails {
    constructor() {
        this.contractGoals = new Array<IContractGoal>();
        this.contractMeasureGroups = new Array<TemplateMeasureDetails>();
    }

    contract: IContract;
    contractType: IContractType;
    contractTerms: IContractTerms;
    contractGoals: Array<IContractGoal>;
    contractMeasureGroups: Array<TemplateMeasureDetails>;
}